import { Component, OnInit } from "@angular/core";
import { AlertService } from "../_services";

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html'
})

export class AlertComponent implements OnInit {
    message: any;

    constructor(private _alertService: AlertService) {
    }

    ngOnInit() {
        this._alertService.getMessage().subscribe(message => {
            if (message) {
                if (typeof message.text == "object" && message.text.error) {
                    const text = message.text;
                    const tmp = text.error.msg == 'Key already exists' ? {
                        text: 'This email is already in used',
                        type: message.type
                    } : { text: text.error.msg, type: message.type };
                    this.message = tmp;
                } else {
                    this.message = message;
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_directives/alert.component.ts